import React, { useState, useEffect } from 'react';
import './SurveyResponsesSurveyList.css';
import SurveyResponsesSurveyCard from './SurveyResponsesSurveyCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';
import Pager from '../Pager/Pager';

const SURVEYS_PER_PAGED_VIEW = 7;

export default function SurveyResponsesSurveyList({ surveyResponsesCollections, onSelect, fullWidth, selectedSurvey }) {
  const [searchTerms, setSearchTerms] = useState('');
  const [visibleSurveyResponsesCollections, setVisibleSurveyResponsesCollections] = useState(surveyResponsesCollections);
  const [currentPage, setCurrentPage] = useState(1);

  if (logComponent('SurveyResponsesSurveyList')) { console.debug('SurveyResponsesSurveyList rendered'); }


  useEffect(() => {
    if (logComponent('SurveyResponsesSurveyList')) { console.debug('SurveyResponsesSurveyList useEffect  [surveyResponsesCollections, searchTerms]'); }
    updateVisibleSurveyResponsesCollections();
  }, [surveyResponsesCollections, searchTerms])


  const updateSearchTerms = (e) => {
    if (logComponent('SurveyResponsesSurveyList')) { console.debug('SurveyResponsesSurveyList updateSearchTerms'); }
    setSearchTerms(e.target.value);
  }


  const updateVisibleSurveyResponsesCollections = () => {
    if (logComponent('SurveyResponsesSurveyList')) { console.debug('SurveyResponsesSurveyList updateVisibleSurveyResponsesCollections'); }

    if (surveyResponsesCollections) {
      let filteredSurveyResponseCollections = surveyResponsesCollections.filter(collection => {

        return collection.survey.surveyName.toLowerCase().includes(searchTerms.toLowerCase());
      });

      setVisibleSurveyResponsesCollections(filteredSurveyResponseCollections);
    }
  }

  const updateSelectedSurvey = (surveyCollectionItem) => {
    if (logComponent('SurveyResponsesSurveyList')) { console.debug('SurveyResponsesSurveyList updateSelectedSurvey'); }
    onSelect(surveyCollectionItem.survey);
  }

  const selectPage = (surveyPage) => {
    if (logComponent('SurveyResponsesSurveyList')) { console.debug('SurveyResponsesSurveyList selectSurveyPage'); }
    if (selectedSurvey && visibleSurveyResponsesCollections && visibleSurveyResponsesCollections.length > 0) {
      let newSelectedSurvey = visibleSurveyResponsesCollections.slice((surveyPage - 1) * SURVEYS_PER_PAGED_VIEW, surveyPage * SURVEYS_PER_PAGED_VIEW)[0].survey;
      onSelect(newSelectedSurvey);

    }

    setCurrentPage(surveyPage);
  }

  return (
    visibleSurveyResponsesCollections &&
    <div className={'Survey-Response-Survey-List' + (fullWidth ? ' Survey-Response-Survey-List--full-width' : '')}>
      <div className="Survey-Response-Survey-List__search-wrapper">
        <FontAwesomeIcon icon="search" className="Survey-Response-Survey-List__search-icon" />
        <input
          type="text"
          className="Survey-Response-Survey-List__search-input"
          placeholder="Search surveys"
          value={searchTerms}
          onChange={updateSearchTerms} />
      </div>
      <div className="Survey-Response-Survey-List__pager">
        <Pager
          items={visibleSurveyResponsesCollections.length}
          onChange={selectPage}
          selectedPage={currentPage}
          pageSize={SURVEYS_PER_PAGED_VIEW}
        />
      </div>
      <ul className="Survey-Response-Survey-List__surveys">
        {
          visibleSurveyResponsesCollections
            .slice((currentPage - 1) * SURVEYS_PER_PAGED_VIEW, currentPage * SURVEYS_PER_PAGED_VIEW)
            .map(surveyCollectionItem =>
              <SurveyResponsesSurveyCard
                key={surveyCollectionItem.survey.surveyId}
                surveyCollectionItem={surveyCollectionItem}
                onClick={updateSelectedSurvey}
                selected={!fullWidth && selectedSurvey ? surveyCollectionItem.survey.surveyId === selectedSurvey.surveyId : false} />
            )
        }
      </ul>
      {
        !visibleSurveyResponsesCollections ||
        (visibleSurveyResponsesCollections &&
          visibleSurveyResponsesCollections.length === 0) &&
        <p className="Survey-Response-Survey-List__empty-message">No surveys found...</p>
      }
    </div>
  );
}